import { gql } from "@apollo/client";
import { episodeMetaFields, liveMetaFields, pageInfoFields, tvShowMetaFields } from "./fragments";
export const SEARCH_META = gql`
  ${episodeMetaFields}
  ${liveMetaFields}
  ${pageInfoFields}
  query SearchEpisode(
    $keyword: String
    $filter: JSONObject
    $sort: String
    $offset: Int
    $limit: Int
    $minScore: Int
  ) {
    search(
      keyword: $keyword
      filter: $filter
      sort: $sort
      offset: $offset
      limit: $limit
      minScore: $minScore
    ) {
      data {
        ... on EpisodeMeta {
          ...episodeMetaFields
        }
        ... on LiveMeta {
          ...liveMetaFields
        }
      }
      pageInfo {
        ...pageInfoFields
      }
    }
  }
`;
export const SEARCH_TVSHOW = gql`
  ${tvShowMetaFields}
  ${pageInfoFields}
  query SearchTvShow(
    $keyword: String
    $filter: JSONObject
    $sort: String
    $offset: Int
    $limit: Int
    $minScore: Int
  ) {
    search: searchTvShow(
      keyword: $keyword
      filter: $filter
      sort: $sort
      offset: $offset
      limit: $limit
      minScore: $minScore
    ) {
      data {
        ... on TVShowMeta {
          ...tvShowMetaFields
        }
      }
      pageInfo {
        ...pageInfoFields
      }
    }
  }
`;